import React from 'react';
import { appChipStyle, getKeyByValue, appIconsPath } from '@utils/globalConstant';
import { tA11y } from '@utils/a11y/a11yHelpers';
import Icons from '@core/Utils/Icons/Icons';
import { useActivation } from '@context/MobileOne';
import Ta11yText from '@core/Ta11yText';

export function ChipTariffBadge({
  chipStyle = appChipStyle.DEFAULT,
  icon = null, // variants: appIconsPath.SIM or appIconsPath.ESIM
  label,
  iconHeight = 14,
  speedName = '',
}) {
  const {getTariffName} = useActivation()
  const chipIcon = getKeyByValue(appIconsPath,icon);
  const tariffName = getTariffName(label, speedName);
  
  return (
    <div className={`d-inline-block px-10 py-6 rounded-10px ${chipStyle}`}>
      <div className="d-flex align-items-center">
        {icon && <Icons name={chipIcon} height={iconHeight} className="pe-6" alt="" colorType='dark' />}
        <Ta11yText
          tag="div"
          textContent={tariffName}
          className="ek-labeltext-12-medium"
        />
      </div>
    </div>
  );
}

export default ChipTariffBadge;
